angular.module('impactx.address').component('ixBasketAddressInput', {
        bindings: {
            handoverAddress: '=',
            readonlyHandover: '=',
            contactAddress: '=',
            readonlyContact: '=',
            invoiceAddress: '=',
            readonlyInvoice: '=',
            deliveryAddress: '=',
            readonlyDelivery: '=',
            trns: '<',
            enableNew: '=',
            enableEdit: '=',
            enableInheritanceOptions: '=',
            enableReadOnlyButtons: '=',
            owningComOptions: '=',
            disableOwningCom: '=',
            saveDirect: '=',
            entryPoint: "@",
            additionalDataForEntryPoint: "=",
            clazz: "@"
        },
        controller: 'BasketAddressInputCtrl',
        templateUrl: 'modules/address/templates/basket-address-input.tmpl.html'
    }
);
